<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>基本信息</span>
      </div>
      <el-form :model="formList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="付款编号：">{{ formList.payNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款类型：">
              {{ payType(formList.payType) }}
              <!-- <template slot-scope="scope">
                                        <p>{{ scope.row.payType | payType }}</p>
              </template>-->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商名称：">
              <span
                style="color:#276CFF"
                v-cust
                @click="goSupperDetail(formList.cid)"
              >{{formList.cname}}</span>
            </el-form-item>
            <!-- formList.suName -->
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申请人：">{{formList.createUser}}</el-form-item>
            <!-- formList.staffCnName -->
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属部门：">{{formList.orgName}}</el-form-item>
            <!-- formList.orgName -->
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{formList.createDate|formatData}}</el-form-item>
          </el-col>
          <!-- 备注后添加 -->
          <el-col :span="8">
            <el-form-item label="备注：">{{formList.allMark || '--'}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content" style="padding-bottom:0;">
      <div class="title-font-style">
        <span>供应商信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px" :model="formList">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="账户名称：">{{formList.receiptName}}</el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="银行账户：">{{formList.receiptBankNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">{{formList.receiptOpenBank}}</el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行账户：">{{formList.receiptBankNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">{{formList.receiptOpenBank}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行行号：">{{formList.receiptOpenNumber}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content" style="padding-bottom:0;">
      <div class="title-font-style">
        <span>付款信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px" :model="formList">
        <el-row :gutter="20"></el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="付款方式：">{{formList.payMethod === 1 ? '银行转账' : '承兑汇票'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款金额：">{{formList.amount}}</el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="票据号码：">{{formList.billNumber}}</el-form-item>
          </el-col>-->
          <!-- <el-col :span="8">
            <el-form-item label="出票行：">{{formList.billBank}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：">{{formList.billCompany}}</el-form-item>
          </el-col>-->
          <!-- <el-col :span="8">
            <el-form-item label="出票日期：">{{formList.billDate}}</el-form-item>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="票据号码：">{{formList.billNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：">{{formList.billCompany}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票行：">{{formList.billBank}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票日期：">{{formList.billDate|dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到期日期：">{{formList.billEnddate|dateFilterD}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item label="到期日期：">{{formList.billEnddate}}</el-form-item>
          </el-col>-->
          <el-col :span="8">
            <el-form-item label="备注：">{{formList.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content" v-show="formList.state === 0">
      <div class="title-font-style">
        <span>处理结果</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item prop="state" label="审核结果：">
              <el-radio v-model="radio" label="1" @change="aross">付款成功</el-radio>
              <el-radio v-model="radio" label="2" @change="lose">付款失败</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="padding-left: 28px;" v-show="isShow">
        <el-form class="details-line-height">
          <!-- <el-row :gutter="20">
          <el-col :span="24">-->
          <el-form-item label="付款凭证：" label-width="70px">
            <el-upload
              show-file-list
              class="upload-demo"
              :limit="3"
              drag
              name="MultipartFile[]"
              :on-success="handleSuccess"
              :on-change="upload"
              :before-upload="berore"
              :file-list="fileList"
              action="/api/systemAttachment/uploadFinanceDraft"
              multiple
              :headers="onheader"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">支持上传文件格式为：pdf文档或图片。最多可上传6个附件且总大小不大于10M</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <el-form
        class="details-line-height"
        style="padding:0px 30px 0 30px"
        :model="formList"
        v-show="remarks"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item label="原因：" prop="exPlain">
              <el-input v-model="formList.exPlain" maxlength="255" type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button
        style="margin-left: 30px;"
        type="primary"
        letter-spacing
        @click="submitBtn('formList')"
      >提交</el-button>
    </div>
  </div>
</template>
<script>
import {
  queryByFprsId,
  updateStateByFprsId
} from '@/api/fiance/fianceManage'
import { getCookie } from '@/util/auth'

export default {
  data () {
    return {
      value: '',
      updown: false,
      markuP: false,
      input: '',
      remarks: false,
      exPlain: '',
      isShow: true,
      formList: {},
      params: {},
      textarea: '',
      radio: '1',
      orderContractStockup: {},
      waitList: [], // 待配货清单
      orderContractStockupStorageVoList: [{}], // 仓库备货区
      orderContractStockupPurchaseVoList: [],
      activeName: '合并计划', // 采购备货区tabs选中状态
      procurementPlanList: [{}], // 采购计划
      purchasingStockAreaTable: [{}],
      rules: { exPlain: { required: true, message: '必填', trigger: 'blur' } },
      fileList: [],
      onheader: {
        Authorization: 'Bearer ' + getCookie('uToken')
      }
    }
  },
  mounted () {
    const { fprsId } = this.$route.query

    queryByFprsId(fprsId)
      .then((res) => {
        if (res.data.code === 200) {
          this.formList = res.data.obj
          console.log(this.formList.allMark)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    // 搜索
    onSearch () {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }

      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
      }
    },
    // 提交
    submitBtn () {
      const {
        formList,
        radio,
        fileList
      } = this
      const upparams = {
        id: formList.id,
        fprId: formList.fprId,
        fprsId: formList.fprsId,
        state: radio,
        amount: formList.amount,
        payMethod: formList.payMethod,
        payId: formList.payId,
        payType: formList.payType,
        pbType: formList.pbType
      }
      if (radio === '1') {
        Object.assign(upparams, {
          financePayRequestAttachmentList: fileList.map(item => {
            return {
              attachment: item.guid,
              id: formList.id,
              fprsId: formList.fprsId
            }
          })
        })
      } else {
        Object.assign(upparams, {
          exPlain: formList.exPlain
        })
      }
      updateStateByFprsId(upparams)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: '提交成功！！',
              type: 'success'
            })
            this.$router.push('/finance/financeManage/waitDisposePayApplyList')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    payType (payType) {
      if (payType === 1) {
        return '客户提现'
      } else if (payType === 2) {
        return '采购付款'
      } else if (payType === 3) {
        return '供应商充值'
      } else if (payType === 4) {
        return '退货罚没金'
      } else if (payType === 5) {
        return '维修付款'
      } else if (payType === 6) {
        return '采购退货罚款'
      }
    },
    // 上传成功
    handleSuccess (response, file, fileList) {
      if (response.code === 200) {
        file.guid = (response.obj && response.obj[0].guid) || ''
        this.fileList = fileList
      } else {
        this.$message.error('上传失败')
        fileList.splice(fileList.length - 1, 1)
      }
    },
    upload (fileList) {
    },

    berore (file, fileList) {
      return true
    },
    // 付款失败
    lose () {
      this.remarks = true
      this.isShow = false
    },
    // 退回重新审核
    send () {
      this.remarks = true
      this.isShow = false
    },
    // 通过
    aross () {
      this.isShow = true
      this.remarks = false
    },
    // 上传付款凭证
    payment () {
      this.updown = true
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    goSupperDetail (id) {
      this.$router.push({ name: 'supplierEdit', query: { id } })
    }
  }
}
</script>
<style lang="less" scoped>
.pay {
  padding-top: 8px;
  font-weight: bold;
}

.payment-voucher {
  padding: 0 30px;
  width: 100%;
}

.lets {
  padding-left: 50px;
  margin-top: 40px;
}

/deep/ .el-upload-dragger {
  height: 80px;
}

/deep/ .el-upload-dragger .el-icon-upload {
  margin: 2px 0 10px 0;
}

/deep/ .el-upload-dragger .el-upload__text {
  line-height: 0;
}

/deep/ .el-upload-dragger .el-icon-upload {
  font-size: 50px;
}

/deep/ .el-upload-dragger {
  width: 100%;
}

/deep/ .el-upload {
  width: 100%;
}

/deep/ .el-input--mini {
  width: 90%;
}
</style>
